import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function LatestUpdate() {
  const sorted = [...comics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );

  return (
    <section className="py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              <i className="ri-time-line text-secondary-500 mr-2"></i>
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新更新的漫画章节</p>
          </div>
          <a href="/category/shaonian" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1">
            全部漫画
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {sorted.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}